import { NgModule } from '@angular/core';
import { LiquidEtherBackgroundComponent } from './liquid-ether-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        LiquidEtherBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        LiquidEtherBackgroundComponent
    ]
})
export class NcLiquidEtherBackgroundModule { }